import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Twitter = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M8.66 19.62c6.795 0 10.512-5.864 10.512-10.948 0-.167 0-.333-.011-.498a7.699 7.699 0 0 0 1.843-1.991 7.147 7.147 0 0 1-2.122.605 3.837 3.837 0 0 0 1.625-2.128 7.228 7.228 0 0 1-2.347.934c-1.145-1.268-2.965-1.579-4.439-.757-1.474.821-2.235 2.57-1.857 4.266-2.97-.155-5.739-1.616-7.615-4.02-.98 1.758-.48 4.007 1.144 5.136a3.556 3.556 0 0 1-1.677-.481v.048c0 1.832 1.24 3.41 2.964 3.772a3.546 3.546 0 0 1-1.668.066c.484 1.567 1.871 2.641 3.452 2.672a7.229 7.229 0 0 1-4.589 1.65c-.294 0-.587-.019-.88-.055a10.16 10.16 0 0 0 5.664 1.725"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Twitter;
